
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46404_9360RDrspZ8BMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[...404].vue?macro=true";
import { default as _91slug_93T88WDu5lo0Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/a/[slug].vue?macro=true";
import { default as indexY1hNDMEDEdMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/a/index.vue?macro=true";
import { default as indexNCpEDwBYqBMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/about-us/index.vue?macro=true";
import { default as indexfmHeOIcDe8Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/attractions/index.vue?macro=true";
import { default as indexedDWyshopsMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/career/index.vue?macro=true";
import { default as indexlNferWYNozMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/contact-us/index.vue?macro=true";
import { default as indexRNiYT7ATtOMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/dinings/index.vue?macro=true";
import { default as indexSfn8pVc7nYMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/events/index.vue?macro=true";
import { default as indexTCJbvHtIr1Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/facilities/index.vue?macro=true";
import { default as indexuRzH6SqyBZMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/gallery/index.vue?macro=true";
import { default as _91slug_93o8lH2V7EncMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/general-terms/[slug].vue?macro=true";
import { default as indexpiEyCD10vVMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/general-terms/index.vue?macro=true";
import { default as indexJYVbGK3it2Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/index.vue?macro=true";
import { default as indexp79HKIj8ijMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/meetings/index.vue?macro=true";
import { default as _91slug_93ZA25UZp1Z8Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/news/[slug].vue?macro=true";
import { default as indexbvjBcAWBB8Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/news/index.vue?macro=true";
import { default as _91id_offer_93IXCbE8GGoUMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/offers/[id_offer].vue?macro=true";
import { default as indexAm0mHBla1NMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/offers/index.vue?macro=true";
import { default as _91slug_93Aba1mB4U9DMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/page/[slug].vue?macro=true";
import { default as indexb8v09y143gMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/reqruitment/index.vue?macro=true";
import { default as _91slug_93Lh7hbWpI13Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/rooms/[slug].vue?macro=true";
import { default as index7VrIskz8EAMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/rooms/index.vue?macro=true";
import { default as _91slug_93MCBB8rlUksMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/whats-new/[slug].vue?macro=true";
import { default as indexczTamApyBzMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/whats-new/index.vue?macro=true";
import { default as indextKI6RCECw0Meta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/index.vue?macro=true";
import { default as not_45found8bVcSkvEwXMeta } from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/not-found.vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[...404].vue")
  },
  {
    name: "additional-slug",
    path: "/:language()/a/:slug()",
    meta: _91slug_93T88WDu5lo0Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/a/[slug].vue")
  },
  {
    name: "additional",
    path: "/:language()/a",
    meta: indexY1hNDMEDEdMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/a/index.vue")
  },
  {
    name: "about-us",
    path: "/:language()/about-us",
    meta: indexNCpEDwBYqBMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/about-us/index.vue")
  },
  {
    name: "attractions",
    path: "/:language()/attractions",
    meta: indexfmHeOIcDe8Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/attractions/index.vue")
  },
  {
    name: "career",
    path: "/:language()/career",
    meta: indexedDWyshopsMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/career/index.vue")
  },
  {
    name: "contact-us",
    path: "/:language()/contact-us",
    meta: indexlNferWYNozMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/contact-us/index.vue")
  },
  {
    name: "dinings",
    path: "/:language()/dinings",
    meta: indexRNiYT7ATtOMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/dinings/index.vue")
  },
  {
    name: "events",
    path: "/:language()/events",
    meta: indexSfn8pVc7nYMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/events/index.vue")
  },
  {
    name: "facilities",
    path: "/:language()/facilities",
    meta: indexTCJbvHtIr1Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/facilities/index.vue")
  },
  {
    name: "gallery",
    path: "/:language()/gallery",
    meta: indexuRzH6SqyBZMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/gallery/index.vue")
  },
  {
    name: "general-terms-slug",
    path: "/:language()/general-terms/:slug()",
    meta: _91slug_93o8lH2V7EncMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/general-terms/[slug].vue")
  },
  {
    name: "general-terms",
    path: "/:language()/general-terms",
    meta: indexpiEyCD10vVMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/general-terms/index.vue")
  },
  {
    name: "home",
    path: "/:language()",
    meta: indexJYVbGK3it2Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/index.vue")
  },
  {
    name: "meetings",
    path: "/:language()/meetings",
    meta: indexp79HKIj8ijMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/meetings/index.vue")
  },
  {
    name: "news-detail",
    path: "/:language()/news/:slug()",
    meta: _91slug_93ZA25UZp1Z8Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/news/[slug].vue")
  },
  {
    name: "news",
    path: "/:language()/news",
    meta: indexbvjBcAWBB8Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/news/index.vue")
  },
  {
    name: "offers-detail",
    path: "/:language()/offers/:id_offer()",
    meta: _91id_offer_93IXCbE8GGoUMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/offers/[id_offer].vue")
  },
  {
    name: "offers",
    path: "/:language()/offers",
    meta: indexAm0mHBla1NMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/offers/index.vue")
  },
  {
    name: "additional-detail",
    path: "/:language()/page/:slug()",
    meta: _91slug_93Aba1mB4U9DMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/page/[slug].vue")
  },
  {
    name: "reqruitment",
    path: "/:language()/reqruitment",
    meta: indexb8v09y143gMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/reqruitment/index.vue")
  },
  {
    name: "rooms-detail",
    path: "/:language()/rooms/:slug()",
    meta: _91slug_93Lh7hbWpI13Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/rooms/[slug].vue")
  },
  {
    name: "rooms",
    path: "/:language()/rooms",
    meta: index7VrIskz8EAMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/rooms/index.vue")
  },
  {
    name: "whats-new-detail",
    path: "/:language()/whats-new/:slug()",
    meta: _91slug_93MCBB8rlUksMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/whats-new/[slug].vue")
  },
  {
    name: "whats-new",
    path: "/:language()/whats-new",
    meta: indexczTamApyBzMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/[language]/whats-new/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indextKI6RCECw0Meta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/index.vue")
  },
  {
    name: "not-found",
    path: "/not-found",
    meta: not_45found8bVcSkvEwXMeta || {},
    component: () => import("/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/pages/not-found.vue")
  }
]